<template>
  <div
    class="line"
    :style="{
      background: color,
      width: width,
      height: height,
      'border-radius': type === 'circle' ? '50%' : null
    }"
  >
    <slot />
  </div>
</template>
<script>
export default {
  name: 'Skeleton',
  props: {
    width: {
      type: String,
      default: '6rem'
    },
    height: {
      type: String,
      default: '1rem'
    },
    type: {
      type: String,
      default: 'rectangle'
    },
    color: {
      type: String,
      default: '#DFDAD2',
      required: false
    }
  }
}
</script>
<style scoped>
.line {
  /* box-shadow: 0 4px 10px 0 rgba(33, 33, 33, 0.15); */
  border-radius: 4px;
  position: relative;
  overflow: hidden;
  margin-bottom: 1rem;
  /* animation: wave-lines 2s infinite ease-out; */
}

.line:before {
  content: '';
  display: block;
  position: absolute;
  left: -150px;
  top: 0;
  height: 100%;
  width: 100%;
  background: linear-gradient(
    to right,
    transparent 0%,
    #f5f2ee 50%,
    transparent 100%
  );
  /* background: #dfdad2; */
  animation: load 1s cubic-bezier(0.4, 0, 0.2, 1) infinite;
}

@keyframes load {
  from {
    left: -150px;
  }
  to {
    left: 100%;
  }
}
</style>
